import { useState } from 'react';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Box, IconButton } from '@mui/material';

export const PanicButton = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setMessage('');
  };
  const handleSend = () => {
    // Aqui você pode disparar o alerta para a equipe de segurança
    handleClose();
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          background: '#F44336',
          color: '#fff',
          boxShadow: '0 2px 8px 0 rgba(244,67,54,0.15)',
          '&:hover': { background: '#D32F2F' },
          width: 35,
          height: 35,
        }}
      >
        <ReportProblemIcon fontSize="medium" />
      </IconButton>
      <Modal
        open={open}
        onClose={handleClose}
        title="Botão do Pânico Ativado"
        description={
          <>Descreva a situação de emergência que está acontecendo. Sua mensagem será enviada imediatamente para a equipe de segurança.</>
        }
        type="danger"
        maxWidth="xs"
        actions={
          <Box display="flex" gap={2} width="100%" justifyContent="center">
            <Button onClick={handleClose} variant="outlined" color="inherit">Cancelar</Button>
            <Button onClick={handleSend} variant="contained" color="error" disabled={!message.trim()}>Enviar Alerta</Button>
          </Box>
        }
      >
        <Input
          multiline
          minRows={4}
          placeholder="Descreva o que está acontecendo..."
          fullWidth
          value={message}
          onChange={e => setMessage(e.target.value)}
          sx={{ mt: 1, background: '#fff', borderRadius: 2 }}
        />
      </Modal>
    </>
  );
}; 